import logger from 'src/logger';
import { SceneComponent } from 'src/sdk-components/SceneComponent';
import { TourObject, VSInteractionType } from 'src/sdk-components/VSObject';
import { TSceneNode } from 'src/service/scene/types';
import { MpSdk } from 'src/types';
import { NodeEventsTypes } from '../../enums';
import Scene from '../../scene';
import { makeTriggerComponent, triggerComponentType } from 'src/sdk-components/TriggerComponent';

class SceneTrigger extends Scene {
  readonly mpSDK: any;

  readonly assets: any = new Map<string, any[]>();

  constructor(mpSDK: MpSdk) {
    super(mpSDK);
    this.mpSDK = mpSDK;
  }

  async init() {
    await this.mpSDK.Scene.register(triggerComponentType, makeTriggerComponent);
  }

  async create(data: any): Promise<TSceneNode | undefined> {
    try {
      const modelNode: any = await this.scene.createNode();

      const initialInputs: SceneComponent['inputs'] = {
        radius: data.radius,
        opacity: data.opacity,
        onClick: data.onClick
      };

      const component: any = modelNode.addComponent(triggerComponentType, initialInputs);

      modelNode.obj3D.position.set(data.positionX, data.positionY, data.positionZ);
      modelNode.obj3D.rotation.set(data.rotationX, data.rotationY, data.rotationZ);
      modelNode.obj3D.scale.set(data.scaleX, data.scaleY, data.scaleZ);

      component.originId = data.id;

      component.onEvent = (type: string, eventData: any) => {
        if (type === VSInteractionType.HOVER) {
          component.handleHover(eventData);
          this.emit(NodeEventsTypes.POLYGON_HOVER, { assetId: data.id, eventData });
        }
        if (type === VSInteractionType.CLICK) {
          component.handleClick();
          this.emit(NodeEventsTypes.POLYGON_CLICK, { assetId: data.id, eventData });
        }

        this.emit(NodeEventsTypes.POLYGON_EVENTS, { type, eventData, component, data });
      };

      await modelNode.start();

      // waiting for all textures to load
      this.assets.set(modelNode.id, [modelNode, component]);

      return [modelNode, component];
    } catch (e) {
      logger.error(e);
    }
    return undefined;
  }

  async remove(data: TourObject) {
    if (this.assets.has(data.id)) {
      const [modelNode] = this.assets.get(data.id);
      if (!modelNode) return;
      modelNode.stop();
    }
  }
}

export default SceneTrigger;
